/**
 * 选中城市的内存 store + localStorage 持久化（UI 偏好，非敏感信息）。
 * 默认 `phnom-penh`。
 */

const CITY_STORAGE_KEY = 'sabay:city-code';
const DEFAULT_CITY = 'phnom-penh';

let selectedCity: string = DEFAULT_CITY;
const subscribers = new Set<() => void>();
let hydrated = false;

function hydrateOnce(): void {
  if (hydrated || typeof window === 'undefined') return;
  hydrated = true;
  try {
    const stored = window.localStorage.getItem(CITY_STORAGE_KEY);
    if (stored) selectedCity = stored;
  } catch {
    // localStorage 被禁用 → 静默回落到内存默认值
  }
}

export function getSelectedCity(): string {
  hydrateOnce();
  return selectedCity;
}

export function setSelectedCity(code: string): void {
  hydrateOnce();
  if (code === selectedCity) return;
  selectedCity = code;
  try {
    window.localStorage.setItem(CITY_STORAGE_KEY, code);
  } catch {
    // ignore
  }
  subscribers.forEach((fn) => fn());
}

export function subscribeSelectedCity(listener: () => void): () => void {
  subscribers.add(listener);
  return () => {
    subscribers.delete(listener);
  };
}
